import { render, staticRenderFns } from "./PreshippingFeedbackModal.vue?vue&type=template&id=358e15ff&scoped=true"
import script from "./PreshippingFeedbackModal.vue?vue&type=script&lang=js"
export * from "./PreshippingFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./PreshippingFeedbackModal.vue?vue&type=style&index=0&id=358e15ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e15ff",
  null
  
)

export default component.exports